import React, { useState } from "react"

interface IParams {
    state: boolean
}

interface IReturnUseSelect {
    openSelect: IParams['state']
    params: IParams
    setOpenSelect: React.Dispatch<React.SetStateAction<IParams['state']>>
    closeSelect: () => void
}

const useSelect = ():IReturnUseSelect => {
    const [openSelect, setOpenSelect] = useState<IParams['state']>(false);
    const [params, setParams] = useState<IParams>({state: false})

    const closeSelect = ():void => {
        setOpenSelect(false)
        setParams({state: false})
    }

    return {
        openSelect,
        params,
        setOpenSelect,
        closeSelect,
    }
}

export default useSelect
